import { PropTypes } from 'prop-types';
import React from 'react';
import _ from 'lodash';

class ActiveFilterList extends React.Component {
    render() {
        let items = [];
        let flatFilter = [];

        _(this.props.filter).forEach((value, name) => {
            if (value) {
                if (name === 'text') {
                    flatFilter.push({ name, value });
                } else {
                    _(value).forEach(val => {
                        flatFilter.push({ name, value: val });
                    });
                }
            }
        });

        _(flatFilter).forEach((f, name) => {
            if (!f) {
                return false;
            }

            let classList = ['active-filter'];
            let filterClick = () => this.props.onFilterClick(f.name, f.value);
            let filterContent = (
                <strong dangerouslySetInnerHTML={{ __html: f.value.name }} />
            );

            if (f.name === 'text') {
                classList.push('text-filter');
                filterClick = this.props.onTextFilterClick;
                filterContent = (
                    <span>
                        Matches <strong>“{this.props.filter.text}”</strong>
                    </span>
                );
            }

            let item = (
                <div
                    key={name}
                    className={classList.join(' ')}
                    onClick={filterClick}
                >
                    {filterContent}
                </div>
            );

            items.push(item);
        });

        if (items.length === 0) {
            return null;
        } else if (items.length > 1) {
            items.push(
                <div
                    key="clear-filter"
                    className="active-filter clear-filter"
                    onClick={this.props.onClearFiltersClick}
                >
                    <i className="icon icon-spinner" /> Clear Filters
                </div>
            );
        }

        return (
            <div className="active-filters">
                <div className="container">
                    <div className="active-filter-items">{items}</div>
                </div>
            </div>
        );
    }
}

ActiveFilterList.propTypes = {
    filter: PropTypes.object.isRequired,
    onFilterClick: PropTypes.func.isRequired,
    onTextFilterClick: PropTypes.func.isRequired,
    onClearFiltersClick: PropTypes.func.isRequired
};

export default ActiveFilterList;
